import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/compress/Index.vue'

Vue.use(VueRouter)
// const BaseConvertSupportType = '.png,.jpg,.jpeg,.bmp,.gif,.webp'
const BASE_KD = {
  keywords: '图片压缩,压缩图片,图片压缩工具,图片压缩软件',
  description:
    '轻秒格式工厂工具是一个在线图片压缩网站，支持JPG压缩、PNG压缩、GIF压缩、BMP压缩等在线压缩功能，并且能够选择压缩大小的范围。支持各类图片格式互转。'
}
const BASE_LIMIT = 12
const routes = [
  {
    path: '/',
    name: 'compress',
    meta: {
      menuCategory: 'imageCompress',
      accept: '.png,.jpg,.jpeg,.bmp,.webp',
      limit: BASE_LIMIT,
      pageTitle: '图片压缩',
      tdk: {
        title: '轻秒格式工厂_图片压缩_在线压缩图片大小_轻秒图片转换器在线',
        ...BASE_KD
      }
    },
    component: Home
  },
  {
    path: '/compress',
    component: () => import('@/App.vue'),
    children: [
      {
        path: '',
        redirect: () => '/'
      },
      {
        path: 'jpg',
        name: 'compress-jpg',
        meta: {
          menuCategory: 'imageCompress',
          accept: '.jpg',
          limit: BASE_LIMIT,
          pageTitle: 'JPG压缩',
          tdk: {
            title: 'JPG压缩-JPG图片压缩-JPG文件在线压缩-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/compress/Index.vue')
      },
      {
        path: 'bmp',
        name: 'compress-bmp',
        meta: {
          menuCategory: 'imageCompress',
          accept: '.bmp',
          limit: BASE_LIMIT,
          pageTitle: 'BMP压缩',
          tdk: {
            title: 'BMP压缩-BMP图片压缩-BMP文件在线压缩-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/compress/Index.vue')
      },
      // {
      //   path: 'gif',
      //   name: 'compress-gif',
      //   meta: {
      //     menuCategory: 'imageCompress',
      //     accept: '.gif',
      //     limit: BASE_LIMIT,
      //     pageTitle: 'GIF压缩',
      //     tdk: {
      //       title: 'GIF压缩-GIF图片压缩-GIF文件在线压缩-轻秒格式工厂',
      //       ...BASE_KD
      //     }
      //   },
      //   component: () => import('@/views/compress/Index.vue')
      // },
      {
        path: 'png',
        name: 'compress-png',
        meta: {
          menuCategory: 'imageCompress',
          accept: '.png',
          limit: BASE_LIMIT,
          pageTitle: 'PNG压缩',
          tdk: {
            title: 'PNG压缩-PNG图片压缩-PNG文件在线压缩-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/compress/Index.vue')
      },
      {
        path: 'webp',
        name: 'compress-webp',
        meta: {
          menuCategory: 'imageCompress',
          accept: '.webp',
          limit: BASE_LIMIT,
          pageTitle: 'WEBP压缩',
          tdk: {
            title: 'WEBP压缩-WEBP图片压缩-WEBP文件在线压缩-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/compress/Index.vue')
      },
      {
        path: 'size',
        name: 'compress-size',
        meta: {
          menuCategory: 'imageCompress',
          accept: '.jpg,.jpeg,.png,.bmp,.webp',
          limit: BASE_LIMIT,
          pageTitle: '图片压缩指定大小',
          tdk: {
            title: '图片压缩指定大小_图片压缩大小至指定kb一下-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/compress/Index.vue')
      },
      {
        path: 'zjz',
        name: 'compress-zjz',
        meta: {
          accept: '.jpg,.jpeg,.png,.bmp,.webp',
          limit: BASE_LIMIT,
          pageTitle: '证件照压缩',
          tdk: {
            title: '证件照压缩_证件照怎么压缩到200kb一下-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/compress/Index.vue')
      }
    ]
  },
  {
    path: '/edit',
    component: () => import('@/App.vue'),
    children: [
      {
        path: '',
        name: 'edit',
        meta: {
          menuCategory: 'imageEdit',
          handlingMethod: 'edit',
          accept: '.jpg,.jpeg,.png,.bmp',
          limit: BASE_LIMIT,
          pageTitle: '图片改尺寸',
          tdk: {
            title: '在线调整图片大小尺寸工具-在线该图片大小-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/edit/Index.vue')
      },
      {
        path: 'dpi',
        name: 'edit-dpi',
        meta: {
          menuCategory: 'imageEdit',
          handlingMethod: 'changeDpi',
          accept: '.jpg,.jpeg,.png',
          limit: BASE_LIMIT,
          pageTitle: '修改DPI',
          tdk: {
            title: '在线修改照片分辨率（DPI）-图片分辨率修改工具-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/edit/Index.vue')
      },
      {
        path: 'increase-memory',
        name: 'increase-memory',
        meta: {
          menuCategory: 'imageEdit',
          handlingMethod: 'increaseMemory',
          accept: '.jpg,.jpeg,.png,.bmp,.webp',
          limit: BASE_LIMIT,
          pageTitle: '内存变大',
          tdk: {
            title: '图片内存怎么调大_怎么可以让照片内存变大-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/edit/Index.vue')
      }
    ]
  },
  {
    path: '/convert',
    component: () => import('@/App.vue'),
    children: [
      {
        path: '',
        name: 'convert',
        meta: {
          menuCategory: 'imageConvert',
          accept: '.jpg,.jpeg,.png,.bmp,.webp',
          convertType: 'auto',
          limit: BASE_LIMIT,
          pageTitle: '图片格式转换',
          tdk: {
            title: '在线图片格式转换器-免费转换图片格式-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/convert/Index.vue')
      },
      {
        path: '2jpg',
        name: 'convert2jpg',
        meta: {
          menuCategory: 'imageConvert',
          accept: '.png,.bmp,.webp',
          limit: BASE_LIMIT,
          convertType: 'jpg',
          pageTitle: '图片转JPG',
          tdk: {
            title: '图片转JPG-在线图片格式转换成JPG-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/convert/Index.vue')
      },
      {
        path: '2bmp',
        name: 'convert2bmp',
        meta: {
          menuCategory: 'imageConvert',
          accept: '.jpg,.jpeg,.png,.webp',
          limit: BASE_LIMIT,
          convertType: 'bmp',
          pageTitle: '图片转BMP',
          tdk: {
            title: '图片转BMP-在线图片格式转换成BMP-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/convert/Index.vue')
      },
      {
        path: '2ico',
        name: 'convert2ico',
        meta: {
          menuCategory: 'imageConvert',
          accept: '.jpg,.jpeg,.png,.bmp,.webp',
          limit: BASE_LIMIT,
          convertType: 'ico',
          pageTitle: '图片转ICO',
          tdk: {
            title: 'JPG、PNG、BMP转ICON-在线将图片转换成ICON格式-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/convert/Index.vue')
      },
      {
        path: '2png',
        name: 'convert2png',
        meta: {
          menuCategory: 'imageConvert',
          accept: '.jpg,.jpeg,.bmp,.webp',
          limit: BASE_LIMIT,
          convertType: 'png',
          pageTitle: '图片转PNG',
          tdk: {
            title: '图片转PNG-在线图片格式转换成PNG-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/convert/Index.vue')
      },
      {
        path: '2webp',
        name: 'convert2webp',
        meta: {
          menuCategory: 'imageConvert',
          accept: '.jpg,.jpeg,.png,.bmp',
          limit: BASE_LIMIT,
          convertType: 'webp',
          pageTitle: '图片转WEBP',
          tdk: {
            title: '图片转WEBP-在线图片格式转换成WEBP-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/convert/Index.vue')
      },
      {
        path: 'heic2jpg',
        name: 'heic2jpg',
        meta: {
          menuCategory: 'imageConvert',
          accept: '.heic',
          limit: BASE_LIMIT,
          convertType: 'jpg',
          pageTitle: 'HEIC转JPG',
          tdk: {
            title: 'HEIC转JPG-在线HEIC格式转换成JPG-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/convert/Index.vue')
      },
      {
        path: 'tiff2jpg',
        name: 'tiff2jpg',
        meta: {
          menuCategory: 'imageConvert',
          accept: '.tiff',
          limit: BASE_LIMIT,
          convertType: 'jpg',
          pageTitle: 'TIFF转JPG',
          tdk: {
            title: 'TIFF转JPG-在线TIFF格式转换成JPG-轻秒格式工厂',
            ...BASE_KD
          }
        },
        component: () => import('@/views/convert/Index.vue')
      }
    ]
  },
  {
    path: '/pdf',
    component: () => import('@/App.vue'),
    children: [
      {
        path: 'compress',
        name: 'pdf_compress',
        meta: {
          menuCategory: 'pdfConvert',
          accept: '.pdf',
          allowedType: ['application/pdf'],
          convertType: 'pdf',
          limit: 1,
          size: 200 * 1024 * 1024,
          pageTitle: 'PDF压缩',
          tdk: {
            title: 'PDF压缩_PDF怎么在线压缩大小-轻秒格式工厂PDF转换在线',
            ...BASE_KD
          }
        },
        component: () => import('@/views/pdf/index.vue')
      },
      {
        path: 'to-word',
        name: 'pdf2word',
        meta: {
          menuCategory: 'pdfConvert',
          accept: '.pdf',
          allowedType: ['application/pdf'],
          convertType: 'doc',
          limit: 1,
          size: 200 * 1024 * 1024,
          pageTitle: 'PDF转Word',
          tdk: {
            title: 'PDF转Word_PDF怎么转换成Word-轻秒格式工厂PDF转换在线',
            ...BASE_KD
          }
        },
        component: () => import('@/views/pdf/index.vue')
      },
      {
        path: 'to-img',
        name: 'pdf2img',
        meta: {
          menuCategory: 'pdfConvert',
          accept: '.pdf',
          allowedType: ['application/pdf'],
          convertType: 'jpg',
          limit: 1,
          size: 200 * 1024 * 1024,
          pageTitle: 'PDF转图片',
          tdk: {
            title: 'PDF转图片_PDF怎么转换成JPG图片-轻秒格式工厂PDF转换在线',
            ...BASE_KD
          }
        },
        component: () => import('@/views/pdf/index.vue')
      },
      {
        path: 'to-ppt',
        name: 'pdf2ppt',
        meta: {
          menuCategory: 'pdfConvert',
          accept: '.pdf',
          allowedType: ['application/pdf'],
          convertType: 'pptx',
          limit: 1,
          size: 200 * 1024 * 1024,
          pageTitle: 'PDF转PPT',
          tdk: {
            title: 'PDF转PPT_怎么把PDF转换成PPT-轻秒格式工厂PDF转换在线',
            ...BASE_KD
          }
        },
        component: () => import('@/views/pdf/index.vue')
      },
      {
        path: 'to-excel',
        name: 'pdf2excel',
        meta: {
          menuCategory: 'pdfConvert',
          accept: '.pdf',
          allowedType: ['application/pdf'],
          convertType: 'xls',
          limit: 1,
          size: 200 * 1024 * 1024,
          pageTitle: 'PDF转Excel',
          tdk: {
            title: 'PDF转Excel_PDF转换成Excel-轻秒格式工厂PDF转换在线',
            ...BASE_KD
          }
        },
        component: () => import('@/views/pdf/index.vue')
      },
      {
        path: 'word2pdf',
        name: 'word2pdf',
        meta: {
          menuCategory: 'pdfConvert',
          accept: '.doc,.docx',
          allowedType: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/wps-writer'
          ],
          convertType: 'pdf',
          limit: 1,
          size: 200 * 1024 * 1024,
          pageTitle: 'Word转PDF',
          tdk: {
            title: 'Word转PDF_Word怎么转PDF-轻秒格式工厂PDF转换在线',
            ...BASE_KD
          }
        },
        component: () => import('@/views/pdf/index.vue')
      },
      {
        path: 'img2pdf',
        name: 'img2pdf',
        meta: {
          menuCategory: 'pdfConvert',
          accept: '.jpg,.jpeg,.png',
          allowedType: ['image/jpeg', 'image/png'],
          convertType: 'pdf',
          limit: 1,
          size: 200 * 1024 * 1024,
          pageTitle: '图片转PDF',
          tdk: {
            title: 'JPG转PDF_图片转PDF_JPG怎么转换成PDF-轻秒格式工厂PDF转换在线',
            ...BASE_KD
          }
        },
        component: () => import('@/views/pdf/index.vue')
      },
      {
        path: 'ppt2pdf',
        name: 'ppt2pdf',
        meta: {
          menuCategory: 'pdfConvert',
          accept: '.ppt,.pptx',
          allowedType: [
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation'
          ],
          convertType: 'pdf',
          limit: 1,
          size: 200 * 1024 * 1024,
          pageTitle: 'PPT转PDF',
          tdk: {
            title: 'PPT转PDF_PPT怎么转换成PDF-轻秒格式工厂PDF转换在线',
            ...BASE_KD
          }
        },
        component: () => import('@/views/pdf/index.vue')
      },
      {
        path: 'excel2pdf',
        name: 'excel2pdf',
        meta: {
          menuCategory: 'pdfConvert',
          accept: '.xls,.xlsx',
          allowedType: [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ],
          convertType: 'pdf',
          limit: 1,
          size: 200 * 1024 * 1024,
          pageTitle: 'Excel转PDF',
          tdk: {
            title: 'Excel转PDF_Excel怎么转PDF-轻秒格式工厂PDF转换在线',
            ...BASE_KD
          }
        },
        component: () => import('@/views/pdf/index.vue')
      },
      {
        path: 'cad2pdf',
        name: 'cad2pdf',
        meta: {
          menuCategory: 'pdfConvert',
          accept: '.dwg,.dxf,.dwt,.dws',
          allowedType: [
            'application/acad',
            'application/x-acad',
            'application/dxf',
            'application/x-dxf',
            'application/x-dwt',
            'application/x-dws',
            'application/octet-stream'
          ],
          convertType: 'pdf',
          limit: 1,
          size: 200 * 1024 * 1024,
          pageTitle: 'CAD转PDF',
          tdk: {
            title: 'CAD转PDF_CAD怎么转换成PDF格式-轻秒格式工厂PDF转换在线',
            ...BASE_KD
          }
        },
        component: () => import('@/views/pdf/index.vue')
      }
    ]
  },
  {
    path: '/about',
    component: () => import('@/App.vue'),
    children: [
      {
        path: '',
        name: 'About',
        meta: {
          tdk: {
            title: '',
            keywords: '',
            description: ''
          }
        },
        component: () => import('@/views/about/index.vue')
      }
    ]
  },
  // {
  //   path: '*',
  //   name: 'NotFound',
  //   redirect: () => '/'
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
      behavior: 'smooth'
    }
  }
})

export default router
